import type { ExportColumnKeys } from "@/modules/export";
import type { ObrasColumnKey } from "./obras-lista.types";

/** Chave do contrato de `GET /api/obras/exportacao` por coluna; a lupa (`null`) não é exportável. */
export const OBRAS_EXPORT_COLUMN_KEYS: ExportColumnKeys<ObrasColumnKey> = {
  id: "id",
  embarcacao: "embarcacao",
  statusObra: "statusObra",
  tipoObra: "tiposObra",
  condicao: "condicao",
  inicio: "inicio",
  termino: "termino",
  duracao: "duracaoTotal",
  realizado: "realizadoBrlMilhoes",
  totalServicos: "totalServicos",
  percServicos: "percentualServicosConcluidos",
  totalMateriais: "totalMateriais",
  percMateriais: "percentualMateriaisEntregues",
  totalFacilidades: "totalFacilidades",
  percFacilidades: "percentualFacilidadesConsumidas",
  detalhamento: null,
};
